import { reducers } from 'redux/core'


const open = () => {
  reducers.view.queueWidget.setOpen(true)
}

const close = () => {
  reducers.view.queueWidget.setOpen(false)
}

export default {
  open,
  close,
}
